import { render, staticRenderFns } from "./quarterly.html?vue&type=template&id=47496a68&"
import script from "./Quarterly.vue?vue&type=script&lang=js&"
export * from "./Quarterly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports